export function objectKeysOnlyStrings (object) {
    const result = {}

    for (const key in object) {
        if (typeof object[key] === 'string') {
            result[key] = object[key]
        }
    }

    return result
}

export function isObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isEmpty(value) {
    return value === '' || value == null
}